import { Avatar, Box, Chip, Typography } from "@mui/joy";

const ProfileHeader = ({ user }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        mb: 3,
        bgcolor: "background.level1",
        p: 3,
        borderRadius: 2,
        boxShadow: 1,
      }}
    >
      <Avatar
        size="lg"
        variant="solid"
        src="/path-to-avatar.jpg"
        sx={{ borderRadius: "50%" }}
      />
      <Box sx={{ flex: 1 }}>
        <Typography level="title-lg" fontWeight="bold">
          {user.first_name || "N/A"} {user.last_name || ""}
        </Typography>
        <Typography level="body-sm" color="neutral">
          {user.email || "N/A"}
        </Typography>
        <Chip color="primary" size="sm">
          {user.role?.toUpperCase() || "N/A"}
        </Chip>
      </Box>
    </Box>
  );
};

export default ProfileHeader;
